<template>
  <div>
    <div class="operation">
      <el-button type="primary" @click="excel" v-if="role_id !== 40001">{{$ct('export')}}</el-button>
    </div>
    <el-table :data="data" style="min-height:300px">
      <el-table-column type="index" width="60" :label="$ct('num')"></el-table-column>
      <el-table-column :label="$ct('name')" width="200">
        <template slot-scope="s">
          <editable-table-cell
            v-if="role_id !== 40001"
            @save="save(s)"
            v-model="s.row.real_name"
            @cancel="cancel(s)"
          />
          <span v-else>{{s.row.real_name}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$ct('unitName')"
        prop="unit_name"
        width="120"
        v-if="role_id === 40001"
      ></el-table-column>
      <el-table-column
        :label="$ct('username')"
        prop="username"
        min-width="120"
        v-if="role_id !== 40001"
      >
        <template slot-scope="s">
          <span>{{handleUsername(s)}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$ct('className')" show-overflow-tooltip>
        <template slot-scope="s">
          <span v-if="role_id !== 40001">{{s.row.class_names ? s.row.class_names.join(',') : ''}}</span>
          <span v-else>{{s.row.class_name}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$ct('email')" prop="email" width="100" v-if="role_id !== 40001"></el-table-column>
      <el-table-column :label="$ct('registration')" prop="created_at" min-width="140">
        <template slot-scope="s">
          <span>{{format(s.row.created_at)}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$ct('activatedTime')" prop="activated_at" min-width="140">
        <template slot-scope="s">
          <span>{{s.row.activated_at ? format(s.row.activated_at) : $ct('unactivated')}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$ct('classScore')" prop="behavior_score" v-if="role_id !== 40001">
        <template slot-scope="s">
          <el-button
            @click.native="editScore(s)"
            size="mini"
            :disabled="!s.row.activated_at"
          >{{s.row.activated_at ? s.row.behavior_score : '-'}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$ct('worksNum')" prop="total_works_count" v-if="role_id !== 40001">
        <template slot-scope="s">
          <el-button
            size="mini"
            style="width:50px"
            @click="checkWork(s)"
          >{{s.row.total_works_count}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$ct('operation')" fixed="right" width="150" v-if="role_id !== 40001">
        <template slot-scope="s">
          <el-button size="mini" @click="resetPwd(s)">{{$ct('resetPassword')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;padding-top:20px"
      background=""
      layout="prev, pager, next,total, jumper"
      :total="total"
      :current-page.sync="page"
      :page-size="limit"
      @current-change="pageChange"
      v-if="total > 0 "
    ></el-pagination>
  </div>
</template>

<script>
import EditableTableCell from '@/components/editableTableCell'
import { funDownload, formatDate } from '@/utils/utils'
export default {
  inject: ['iPath'],
  components: {
    EditableTableCell
  },
  props: {
    loading: Boolean,
    data: Array
  },
  data() {
    return {
    }
  },
  computed: {
    page: {
      get() {
        return this.$store.state.studentManage.page
      },
      set(page) {
        this.$store.commit('setState', {
          module: 'studentManage',
          key: 'page',
          value: page
        })
      }
    },
    total() {
      return this.$store.state.studentManage.total
    },
    limit() {
      return this.$store.state.studentManage.limit
    },
    role_id() {
      return this.$store.state.user.role_id
    }
  },
  methods: {
    save(s) {
      const index = s.$index
      if (s.row.real_name === s.row.initName) {
        return
      }
      const data = {
        id: s.row.id,
        real_name: s.row.real_name
      }
      if (!s.row.real_name) {
        this.$message({
          type: 'error',
          message: '修改失败,学生名不能为空'
        })
        s.row.real_name = s.row.initName
        this.data.splice(index, 1, s.row)
        return
      }
      this.$store.dispatch('studentManageEditName', data).then((msg) => {
        this.$message({
          message: msg.status < 400 ? this.$ct('csuccess') : this.$ct('cfail'),
          type: msg.status < 400 ? 'success' : 'error'
        })
        if (msg.status >= 400) {
          s.row.name = s.row.initName
          this.data.splice(index, 1, s.row)
        } else {
          s.row.initName = s.row.name
          this.data.splice(index, 1, s.row)
        }
      })
    },
    cancel() {},
    pageChange(page) {
      this.page = page
      this.$emit('getData')
    },
    editScore(s) {
      this.$emit('editScore', s)
    },
    excel() {
      this.$store.dispatch('studentManageExcel').then((res) => {
        if (res.status < 400) {
          this.$message({
            type: 'success',
            message: this.$ct('csuccess')
          })
          funDownload(res.data, this.$ct('excel.students'))
        }
      })
    },
    resetPwd(s) {
      this.$emit('resetPwd', s)
    },
    // 格式化
    format(date) {
      return formatDate(date)
    },
    handleUsername(s) {
      if (s.row.username) {
        return s.row.username
      } else {
        return '-'
      }
    },
    // 查看作品
    checkWork(s) {
      this.$store.commit('setState', {
        module: 'workManage',
        key: 'user_id',
        value: s.row.id
      })
      this.$router.push(this.iPath({
        name: 'workManage'
      }))
    }
  }
}
</script>
